// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"styles_tooltipContent__1MJq6","tooltipWrapper":"styles_tooltipWrapper__1PRSW"};